import React from 'react';
import { node } from 'prop-types';

import Box from '../atoms/Box';

const StatusTag = ({ children }) => {
  return (
    <Box
      borderRadius={3}
      border="1px solid"
      borderColor="greyVerylight"
      fontWeight="700"
      display="inline-block"
      px={3}
      py={1}>
      {children}
    </Box>
  );
};

StatusTag.propTypes = {
  children: node
};

export default StatusTag;
